import React, { Component } from 'react';
import '../css/Contact.css'

export default class Contact extends Component {

    data = JSON.parse(sessionStorage.getItem("data"));

    contacts = this.data.contactDetails.directContacts;

    render() {
        return (
            <div>
                <p id="contactEmail">Email:<br />{this.data.contactDetails.email}</p>
                {this.contacts.map((contact, key) => ([
                    <p key={key}>
                        <span className="contactName">{contact.name}</span><br />
                        <span className="contactNumber">{contact.number}</span><br />
                        <span className="contactRelationship">{contact.relationship}</span>
                    </p>
                ]))}
                {/* { this.data.contactDetails.directContacts} */}
            </div>
        );

    }
}